import { useBudgetOnboardingContext } from '@/components/cashflow/budget/BudgetOnboardingContext';
import { BudgetOnboardingSteps } from '@/components/cashflow/budget/BudgetOnboardingSteps';
import { FlexCol, FlexRow } from '@/components/common/Flex';
import PlentyLogo from '@/components/common/PlentyLogo';
import { scrollShadowStyle } from '@/components/common/styleHelpers';
import { ModalCloseButton } from '@chakra-ui/react';

interface BudgetOnboardingModalHeaderProps {
    children: React.ReactNode;
}

export const BudgetOnboardingModalContent = ({
    children,
}: BudgetOnboardingModalHeaderProps) => {
    const { variant } = useBudgetOnboardingContext();

    return (
        <>
            <ModalCloseButton size="lg" color="textMuted" zIndex="modal" />
            <FlexCol p={12} {...scrollShadowStyle()} borderRadius={6}>
                <FlexRow justify="space-between" align="center" mb={8}>
                    <PlentyLogo />
                    {variant === 'create' && <BudgetOnboardingSteps />}
                </FlexRow>

                {children}
            </FlexCol>
        </>
    );
};
